'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _assetsContainer = require('../../libs/assetsContainer');

var _assetsContainer2 = _interopRequireDefault(_assetsContainer);

var _media = require('../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Libs


var Portal = function Portal(_ref) {
  var children = _ref.children,
      container = _ref.container,
      size = _ref.size,
      always = _ref.always;
  return always || (0, _jquery2.default)(window).width() <= _media.breakingpoints[size] ? (0, _reactDom.createPortal)(children, (0, _assetsContainer2.default)(container)) : children;
}; // Media


Portal.propTypes = {
  children: _propTypes2.default.node,
  container: _propTypes2.default.oneOf([_assetsContainer.PRIMARY_ASSETS_CONTAINER_ID, _assetsContainer.SECONDARY_ASSETS_CONTAINER_ID]),
  size: _propTypes2.default.oneOf(['s', 'm', 'l']),
  always: _propTypes2.default.bool
};
Portal.defaultProps = {
  size: 's',
  always: false,
  container: _assetsContainer.PRIMARY_ASSETS_CONTAINER_ID
};
Portal.assetsContainer = {
  primary: _assetsContainer.PRIMARY_ASSETS_CONTAINER_ID,
  secondary: _assetsContainer.SECONDARY_ASSETS_CONTAINER_ID
};
exports.default = Portal;